import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Login from "./components/login";
import DSGVO from "./components/DSGVO";
import Impressum from "./components/Impressum";
import Settings from "./components/Settings";
import Logout from "./components/logout";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

function ProtectedRoute({ children }) {
  const session = localStorage.getItem("session");

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

let root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dsgvo" element={<DSGVO/>} />
      <Route path="/datenschutz" element={<DSGVO/>} />
      <Route path="/impressum" element={<Impressum/>} />
      <Route path="/settings" element={<Settings/>}/>
      <Route path="/logout" element={<Logout/>}/>

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        }
      />
    </Routes>
  </BrowserRouter>
);
